import { render } from "./BannerView.vue?vue&type=template&id=68737855"
import script from "./BannerView.vue?vue&type=script&lang=js"
export * from "./BannerView.vue?vue&type=script&lang=js"

import "./BannerView.vue?vue&type=style&index=0&id=68737855&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__